module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_17-83264b6b6ad778267da25cf1ce4080d8.jpg";